import Wrap from './styles';

import Animation from 'services/utils/Animation';

import AppContext from '@map/services/context';
/**
 * useContext usado para forcener uma maneira de passar dados
 * pela arvore de componentes sem ter que passar props manualmente
 * em todos os níveis.
 * 
 * useEffect é um hook que permite executar efeitos colaterais em
 * seus componentes, por exemplo: buscar dados, atualizar diretamente
 * o DOM e cronômetros, ele aceita dois argumentos o segundo é opcional.
 * 
 * useRef permite que persista valores entre renderizações, ele pode
 * ser usado para armazenar um valor mutável que não causa uma nova
 * renderização quando atualizado e pode ser usado para acessar di-
 * retamente um elemento do DOM.
 */
import { useContext, useEffect, useRef } from 'react';

const SideBar = (props) => {
  const {
    sideBarIsOpened,
    sideBarTitle,
    SideBarComponent,
    backSideBarHistory,
    closeSideBar,
  } = useContext(AppContext);

  const section = useRef(null);

  useEffect(() => {
    if (SideBarComponent) {
      // Caso altere o componente, executa animação de transição
      const animation = new Animation(
        300,
        (stepNumber) => {
          let changeSide = false;
          if (!changeSide) {
            changeSide = true;
            section.current.style.opacity = 0;
            section.current.style.transform = 'translateX(150px)';
          }
          section.current.style.transform = `translateX(${
            -150 * stepNumber + 150
          }px)`;
          section.current.style.opacity = stepNumber;
        },
        () => {
          section.current.style.transform = 'translateX(0px)';
          section.current.style.opacity = 1;
        }
      );
      animation.start();
    }
  }, [SideBarComponent]);
/**
 * @returns MOBILE
 * Um icone de seta 
 * usado para esconder o menu lateral da direita
 */
  return (
    <Wrap isOpened={sideBarIsOpened}>
      <div className="courtain" onClick={(e) => closeSideBar()} />
      <header>
        <button
          type="button"
          onClick={(e) => {
            backSideBarHistory();
          }}
        >
          <svg
            width="9"
            height="17"
            viewBox="0 0 9 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.46055 0.240317C8.38206 0.170318 8.29052 0.116499 8.19118 0.0819466C8.09185 0.0473938 7.98667 0.0327861 7.88168 0.0389612C7.77669 0.0451363 7.67395 0.0719726 7.57935 0.117932C7.48475 0.163891 7.40015 0.228069 7.3304 0.306787L0.923655 7.51438C0.793318 7.66087 0.721313 7.85013 0.721313 8.04622C0.721313 8.2423 0.793318 8.43156 0.923655 8.57805L7.3304 15.7856C7.47327 15.9374 7.66969 16.0275 7.87792 16.0368C8.08616 16.0461 8.28981 15.9738 8.4456 15.8353C8.60139 15.6968 8.69705 15.503 8.71225 15.2952C8.72746 15.0873 8.66101 14.8816 8.52702 14.722L2.59341 8.04622L8.52702 1.37047C8.59693 1.29193 8.65067 1.20038 8.68517 1.10105C8.71967 1.00173 8.73425 0.896577 8.72808 0.791612C8.7219 0.686648 8.6951 0.58393 8.64919 0.489333C8.60329 0.394737 8.53919 0.310118 8.46055 0.240317Z"
              fill="#BDBDBD"
            />
          </svg>
        </button>
        <h1>{sideBarTitle}</h1>
      </header>
      <section
        ref={section}
        style={{
          opacity: 0.5,
          transform: 'translateX(20px)',
        }}
      >
        {SideBarComponent}
      </section>
    </Wrap>
  );
};

SideBar.properties = {
  id: 'CPN-HB-MOBILE_SIDEBAR',
  alias: 'Menu mobile lateral retrátil',
  description:
    'Menu mobile para exibir informações de artefatos externos ao mapa, apresentado como uma barra lateral que vem da esquerda',
  ignore: true,
};

export default SideBar;
